import script from "./HomeTopComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTopComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeTopComponent.vue?vue&type=style&index=0&id=8c3f0fce&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c3f0fce"]])

export default __exports__